import React, { ReactNode } from "react";
import FeishuIcon from "src/assets/feishu-switch.svg";
import WeworkIcon from "src/assets/wework-switch.svg";
import styles from "./index.module.scss";

interface QrloginSwitcherProps {
  platform: "wework" | "feishu";
  onChange: (platform: "wework" | "feishu") => void;
  showSwitcher: boolean;
  children: ReactNode;
}

export default function QrloginSwitcher({
  platform,
  onChange,
  showSwitcher,
  children,
}: QrloginSwitcherProps) {
  return (
    <div className={styles.switch_container}>
      {children}
      {showSwitcher && (
        <>
          <div className={styles.divider}></div>
          <div
            className={styles.switch_btn}
            onClick={() => onChange(platform === "wework" ? "feishu" : "wework")}
          >
            <img src={platform === "wework" ? FeishuIcon : WeworkIcon} alt="switch" />
            <span>
              {platform === "wework"
                ? "切换至飞书扫码登录"
                : "切换至企业微信扫码登录"}
            </span>
          </div>
        </>
      )}
    </div>
  );
}